import { EAccess, EAccessMethod } from "@app/access/access.model";
import { EvideTableColumn, EvideTableColumnType } from "../common/common.model";

export interface INotificationTemplateParameterInfoHttpResponse {
    id: number;
    notificationTemplateId: number;
    notificationTemplateTypeCode: string;
    notificationTemplateDescription: string;
    parameterName: string;
    notificationParameterTypeId: number;
    notificationParameterTypeName: string;
    notificationParameterValueTypeId: number;
    notificationParameterValueTypeName: string;
    notificationParameterInputTypeId: number;
    notificationParameterInputTypeName: string;
}

export class NotificationTemplateParameterInfo {
    constructor(
        public id: number,
        public notificationTemplateId: number,
        public notificationTemplateTypeCode: string,
        public notificationTemplateDescription: string,
        public parameterName: string,
        public notificationParameterTypeId: number,
        public notificationParameterTypeName: string,
        public notificationParameterValueTypeId: number,
        public notificationParameterValueTypeName: string,
        public notificationParameterInputTypeId: number,
        public notificationParameterInputTypeName: string
    ) { }

    public static adapt(data: INotificationTemplateParameterInfoHttpResponse) {
        return new this(
            data.id,
            data.notificationTemplateId,
            data.notificationTemplateTypeCode,
            data.notificationTemplateDescription,
            data.parameterName,
            data.notificationParameterTypeId,
            data.notificationParameterTypeName,
            data.notificationParameterValueTypeId,
            data.notificationParameterValueTypeName,
            data.notificationParameterInputTypeId,
            data.notificationParameterInputTypeName
        );
    }
}

export const NotificationTemplateParameterInfoColumns: Readonly<EvideTableColumn[]> = [
    {
        key: 'notificationTemplateTypeCode',
        type: EvideTableColumnType.String,
        title: 'Type Code',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'notificationTemplateDescription',
        type: EvideTableColumnType.String,
        title: 'Description',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'parameterName',
        type: EvideTableColumnType.String,
        title: 'Parameter Name',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'notificationParameterTypeName',
        type: EvideTableColumnType.String,
        title: 'Parameter Type Name',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'notificationParameterValueTypeName',
        type: EvideTableColumnType.String,
        title: 'Parameter Value Type',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'notificationParameterInputTypeName',
        type: EvideTableColumnType.String,
        title: 'Parameter Input Type',
        displayValue: true,
        sortable: true,
        isFormEditableField: false
    },
    {
        key: 'options',
        type: EvideTableColumnType.Options,
        matIcon: 'more_vert',
        title: 'Options',
        optionMenu: [
            {
                key: 'edit',
                type: EvideTableColumnType.Action,
                matIcon: 'fa fa-fw fa-pen',
                title: 'Edit',
                accessVisibility: {
                    controllerKey: EAccess.NotificationTemplateParameter,
                    methodKey: EAccessMethod.Put
                }
            },
            {
                key: 'delete',
                type: EvideTableColumnType.Action,
                matIcon: 'fa fa-fw fa-trash-alt',
                title: 'Delete',
                accessVisibility: {
                    controllerKey: EAccess.NotificationTemplateParameter,
                    methodKey: EAccessMethod.Delete
                }
            }
        ]
    }
];